import React, { CSSProperties } from 'react';
import classNames from 'classnames';

import * as Types from 'types';

import { PlayableArtworkThumbnail } from 'components/artworks/PlayableArtworkThumbnail';
import { ArtworkTitle } from 'components/artworks/ArtworkTitle';
import { EditionInfo } from 'editions/EditionInfo';

import { ArtworkThumbnail } from 'components/artworks/ArtworkThumbnail';

enum STEP {
  FIRST = 1,
  SECOND = 2,
}

type Props = {
  edition: Types.Edition;
  artwork: Types.Artwork;
  nftIndicatorEnabled?: boolean;
  editionInfoStyle?: CSSProperties;
  context?: 'grid' | 'modal';
  onPlay?: () => void;
  setStep?: (step: STEP) => void;
} & Types.Styleable;

export const Edition: React.FC<Props> = ({
  className,
  style,
  artwork,
  edition,
  editionInfoStyle = {},
  nftIndicatorEnabled = true,
  context = 'grid',
  onPlay,
  setStep,
}) => {
  const isMinted = Boolean(edition?.certificate?.ownerAddress);

  return (
    <div className={classNames('artwork-component', className)} style={style}>
      {onPlay ? (
        <PlayableArtworkThumbnail artwork={artwork} onPlay={onPlay} style={{ cursor: 'default' }} />
      ) : (
        <ArtworkThumbnail artwork={artwork} />
      )}
      {edition ? (
        <EditionInfo
          edition={{ ...edition, artwork }}
          nftIndicatorEnabled={nftIndicatorEnabled}
          style={{ ...editionInfoStyle, marginTop: '6px' }}
        />
      ) : null}
      <div className='entity-list__content entity-list__content--primary'>
        <ArtworkTitle
          onClick={context === 'grid' ? () => setStep?.(1) : undefined}
          url={context === 'modal' ? artwork.url : undefined}
          artwork={artwork}
          className='artwork-header--sm'
          maxlength={60}
          secondaryColumn
          showPrice={false}
          enableNftIndicator={false}
        />
        {artwork.nft && context === 'grid' && (
          <button
            className='btn btn--border-vault btn--border-light w-100 mt-mini fw-500'
            onClick={() => setStep?.(STEP.SECOND)}
          >
            {isMinted ? 'View NFT' : 'Mint NFT'}
          </button>
        )}
      </div>
    </div>
  );
};
